
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.b1511411862 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":".",",":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b757270678 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":".",",":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b741502550 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":".",",":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a293633841 = numberParserFn([{".":".",",":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.b269043170 = pluralGeneratorFn(function(n
) {
  return 'other';
});
Globalize.a187018708 = messageFormatterFn((function(  ) {
  return function(d) { return "เข้าสู่ระบบ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a588106998 = messageFormatterFn((function(  ) {
  return function(d) { return "เข้าสู่ระบบ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1934051275 = messageFormatterFn((function(  ) {
  return function(d) { return "อีเมล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a2084838660 = messageFormatterFn((function(  ) {
  return function(d) { return "รหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a789021859 = messageFormatterFn((function(  ) {
  return function(d) { return "กำลังใช้อุปกรณ์สาธารณะหรือใช้ร่วมกัน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1717348316 = messageFormatterFn((function(  ) {
  return function(d) { return "ไม่ได้ใช้อุปกรณ์ของตัวเอง? กรุณาทำเครื่องหมายที่ช่องสี่เหลี่ยมเพื่อออกจากระบบโดยอัตโนมัติเร็วขึ้นเมื่อไม่มีการใช้งาน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1532212087 = messageFormatterFn((function(  ) {
  return function(d) { return "ให้ฉันอยู่ในระบบเสมอ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1247924647 = messageFormatterFn((function(  ) {
  return function(d) { return "การทำเครื่องหมายที่ช่องนี้จะทำให้คุณอยู่ในระบบในอุปกรณ์นี้ด้วยบัญชีของคุณจนกระทั่งคุณลงชื่อออกจากระบบ กรุณาอย่าทำเครื่องหมายที่ช่องนี้หากคุณใช้อุปกรณ์นี้ร่วมกับผู้อื่น"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1443186079 = messageFormatterFn((function(  ) {
  return function(d) { return "ลืมรหัสผ่าน?"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b410074352 = messageFormatterFn((function(  ) {
  return function(d) { return "ดำเนินการต่อ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1429396451 = messageFormatterFn((function(  ) {
  return function(d) { return "ยกเลิก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b270194746 = messageFormatterFn((function(  ) {
  return function(d) { return "ย้อนกลับ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1346259256 = messageFormatterFn((function(  ) {
  return function(d) { return "โหลดอีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a907174925 = messageFormatterFn((function(  ) {
  return function(d) { return "ในการเข้าสู่ระบบ ฉันได้ยอมรับ<a href=" + d["1"] + " " + d["3"] + ">ข้อกำหนดและเงื่อนไข</a>และ<a href=" + d["2"] + " " + d["4"] + ">นโยบายความเป็นส่วนตัว</a>ของ " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b279172747 = messageFormatterFn((function(  ) {
  return function(d) { return "ในการเข้าสู่ระบบ ฉันได้ยอมรับ<a href=" + d["1"] + " " + d["5"] + ">ข้อกำหนดและเงื่อนไข</a> <a href=" + d["2"] + " " + d["6"] + ">นโยบายความเป็นส่วนตัว</a> และ<a href=" + d["3"] + " " + d["7"] + ">ข้อกำหนดและเงื่อนไข " + d["4"] + "</a> ของ " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1337380797 = messageFormatterFn((function(  ) {
  return function(d) { return "ในการเข้าสู่ระบบ ฉันจะได้เข้าร่วม " + d["4"] + " โดยอัตโนมัติ ฉันยอมรับ<a href=" + d["1"] + " " + d["5"] + ">ข้อกำหนดและเงื่อนไข</a>และ<a href=" + d["2"] + " " + d["6"] + ">นโยบายความเป็นส่วนตัว</a>ของ " + d["0"] + " รวมถึง<a href=" + d["3"] + " " + d["7"] + ">ข้อกำหนดและเงื่อนไข " + d["4"] + "</a>"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a390976152 = messageFormatterFn((function(  ) {
  return function(d) { return "บัญชีของคุณถูกระงับชั่วคราวหลังการตรวจสอบความปลอดภัยตามปกติ ข้อมูลของคุณปลอดภัยดี แต่คุณจำเป็นต้องรีเซ็ตรหัสผ่าน กรุณาคลิกที่ลิงก์ \"ลืมรหัสผ่าน?\" ด้านล่างเพื่อรีเซ็ตรหัสผ่านและเข้าสู่ระบบ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b124802094 = messageFormatterFn((function(  ) {
  return function(d) { return "อีเมลและรหัสผ่านไม่ตรงกัน กรุณาลองอีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b80419895 = messageFormatterFn((function(  ) {
  return function(d) { return "ขออภัย เกิดข้อผิดพลาดในระบบ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1323273103 = messageFormatterFn((function(  ) {
  return function(d) { return "ขออภัย เกิดข้อผิดพลาดในระบบ โปรดลองอีกครั้งในอีกสักครู่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a442326445 = messageFormatterFn((function(  ) {
  return function(d) { return "กรุณาป้อนอีเมลของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1715360450 = messageFormatterFn((function(  ) {
  return function(d) { return "ป้อนอีเมลที่ถูกต้อง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b308640900 = messageFormatterFn((function(  ) {
  return function(d) { return "กรุณาป้อนรหัสผ่านของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1173623078 = messageFormatterFn((function(  ) {
  return function(d) { return "กำลังตรวจสอบชื่อผู้ใช้และรหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1545876129 = messageFormatterFn((function(  ) {
  return function(d) { return "ซ่อนรหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1231533990 = messageFormatterFn((function(  ) {
  return function(d) { return "แสดงรหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1246852004 = messageFormatterFn((function(  ) {
  return function(d) { return "ยังไม่มีบัญชี? <span><a id=\"createAcctRedirectLink\" href=" + d["0"] + ">สร้างได้ที่นี่</a></span>"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a200172265 = messageFormatterFn((function(  ) {
  return function(d) { return "เข้าสู่ระบบ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a233073888 = messageFormatterFn((function(  ) {
  return function(d) { return "ไม่สามารถเข้าสู่ระบบผ่าน " + d["0"] + " ได้อีกต่อไป"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1524103108 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณสามารถใช้อีเมลเดิมเพื่อถึงบัญชี " + d["0"] + " พร้อมตั้งรหัสผ่านใหม่ จะไม่มีผลต่อบัญชี " + d["1"] + " ของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b589583886 = messageFormatterFn((function(  ) {
  return function(d) { return "ตั้งรหัสผ่านใหม่โดยใช้ปุ่มด้านล่าง ครั้งต่อไป โปรดใช้อีเมลและรหัสผ่านใหม่เพื่อเข้าสู่ระบบ " + d["0"] + " โดยตรง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b516587029 = messageFormatterFn((function(  ) {
  return function(d) { return "เข้าสู่ระบบ SSO"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1610164237 = messageFormatterFn((function(  ) {
  return function(d) { return "เข้าสู่ระบบโดยใช้การเข้าสู่ระบบแบบครั้งเดียว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1162917473 = messageFormatterFn((function(  ) {
  return function(d) { return "หรือเข้าสู่ระบบด้วยบัญชี " + d["0"] + " ของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1583941484 = messageFormatterFn((function(  ) {
  return function(d) { return "สะสมคะแนนเพื่อเดินทางฟรี รับส่วนลดพิเศษสำหรับสมาชิก ดูแผนการเดินทางได้ง่ายๆ ทันที"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1512539730 = messageFormatterFn((function(  ) {
  return function(d) { return "รับคะแนน Expedia Rewards " + d["0"] + " คะแนนหลังจากทริปนี้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b843407371 = messageFormatterFn((function(  ) {
  return function(d) { return "เข้าสู่ระบบบัญชี " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b194756787 = messageFormatterFn((function(  ) {
  return function(d) { return "เปิดในแท็บใหม่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1428154833 = messageFormatterFn((function(  ) {
  return function(d) { return "ข้อกำหนดและเงื่อนไข (" + d["0"] + ")"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1275000655 = messageFormatterFn((function(  ) {
  return function(d) { return "นโยบายความเป็นส่วนตัว (" + d["0"] + ")"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1146287148 = messageFormatterFn((function(  ) {
  return function(d) { return "ข้อกำหนดและเงื่อนไขของโปรแกรมสมาชิก One Key (" + d["0"] + ") "; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1330980599 = messageFormatterFn((function(  ) {
  return function(d) { return "ลืมรหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a389007822 = messageFormatterFn((function(  ) {
  return function(d) { return "ตั้งรหัสผ่านใหม่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1225977112 = messageFormatterFn((function(  ) {
  return function(d) { return "ป้อนอีเมลของคุณเพื่อรับลิงก์สำหรับตั้งรหัสผ่านใหม่จากเรา"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1254227116 = messageFormatterFn((function(  ) {
  return function(d) { return "ส่งลิงก์"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a217579279 = messageFormatterFn((function(  ) {
  return function(d) { return "เช็คอีเมลของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1295467593 = messageFormatterFn((function(  ) {
  return function(d) { return "เราได้ส่งลิงก์ตั้งรหัสผ่านใหม่ไปยัง " + d["0"] + " แล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1295466632 = messageFormatterFn((function(  ) {
  return function(d) { return "การส่งอีเมลอาจใช้เวลาสักครู่ หากคุณไม่ได้รับอีเมลจากเราภายใน 10 นาที ลองเช็คที่กล่องเมลขยะหรือสแปม"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1088088990 = messageFormatterFn((function(  ) {
  return function(d) { return "ส่งลิงก์อีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1684028250 = messageFormatterFn((function(  ) {
  return function(d) { return "เราได้ส่งลิงก์ใหม่ไปให้คุณแล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a603723443 = messageFormatterFn((function(  ) {
  return function(d) { return "กำลังยืนยันบัญชี"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1711706867 = messageFormatterFn((function(  ) {
  return function(d) { return "ตั้งรหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b193474652 = messageFormatterFn((function(  ) {
  return function(d) { return "ยินดีต้อนรับอีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a158470018 = messageFormatterFn((function(  ) {
  return function(d) { return "กรุณาสร้างรหัสผ่านที่ยากต่อการคาดเดา"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1761952077 = messageFormatterFn((function(  ) {
  return function(d) { return "สำเร็จ!"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1312399850 = messageFormatterFn((function(  ) {
  return function(d) { return "ตอนนี้คุณสามารถเข้าสู่ระบบด้วยรหัสผ่านใหม่นี้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1174548965 = messageFormatterFn((function(  ) {
  return function(d) { return "ตั้งรหัสผ่านใหม่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b549457022 = messageFormatterFn((function(  ) {
  return function(d) { return "ขออภัย คำขอตั้งรหัสผ่านใหม่นี้หมดอายุแล้ว หากคุณต้องการเปลี่ยนรหัสผ่าน กรุณาคลิกที่ลิงก์ด้านล่างเพื่อส่งคำขอตั้งรหัสผ่านใหม่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a399782162 = messageFormatterFn((function(  ) {
  return function(d) { return "ส่งลิงก์อีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1243447875 = messageFormatterFn((function(  ) {
  return function(d) { return "กำลังบันทึกรหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a2103577071 = messageFormatterFn((function(  ) {
  return function(d) { return "สร้างบัญชี"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b421961571 = messageFormatterFn((function(  ) {
  return function(d) { return "สร้างบัญชี"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a250123182 = messageFormatterFn((function(  ) {
  return function(d) { return "อีเมล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a258851878 = messageFormatterFn((function(  ) {
  return function(d) { return "กรุณาป้อนอีเมลของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1988256503 = messageFormatterFn((function(  ) {
  return function(d) { return "ป้อนอีเมลที่ถูกต้อง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1444707789 = messageFormatterFn((function(  ) {
  return function(d) { return "ชื่อ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a925151813 = messageFormatterFn((function(  ) {
  return function(d) { return "กรุณาป้อนชื่อของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1221170289 = messageFormatterFn((function(  ) {
  return function(d) { return "นามสกุล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b735252231 = messageFormatterFn((function(  ) {
  return function(d) { return "กรุณาป้อนนามสกุลของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1574726158 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดป้อนชื่อโดยใช้ตัวอักษรภาษาอังกฤษเท่านั้น"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a2071552747 = messageFormatterFn((function(  ) {
  return function(d) { return "รหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a115130227 = messageFormatterFn((function(  ) {
  return function(d) { return "กรุณาป้อนรหัสผ่านของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1619369214 = messageFormatterFn((function(  ) {
  return function(d) { return "กรุณาป้อนรหัสผ่านที่ถูกต้อง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1779752578 = messageFormatterFn((function(  ) {
  return function(d) { return "ความยาว 9-64 ตัว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1779751617 = messageFormatterFn((function(  ) {
  return function(d) { return "มีทั้งตัวอักษรและตัวเลข"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1779750656 = messageFormatterFn((function(  ) {
  return function(d) { return "อักขระพิเศษ ~ " + "#" + " @ $ % & ! * _ ? ^ -"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1779749695 = messageFormatterFn((function(  ) {
  return function(d) { return "รหัสผ่านต้องไม่เว้นวรรค"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b834118856 = messageFormatterFn((function(  ) {
  return function(d) { return "รหัสผ่านต้องมีความยาว 8-64 ตัว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1770709659 = messageFormatterFn((function(  ) {
  return function(d) { return "รหัสผ่านต้องไม่เหมือนกับอีเมล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1654511074 = messageFormatterFn((function(  ) {
  return function(d) { return "รหัสผ่านต้องไม่เว้นวรรค"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1885425766 = messageFormatterFn((function(  ) {
  return function(d) { return "ในการสร้างบัญชี ฉันได้ยอมรับ<a href=" + d["1"] + " " + d["3"] + ">ข้อกำหนดและเงื่อนไข</a>และ<a href=" + d["2"] + " " + d["4"] + ">นโยบายความเป็นส่วนตัว</a>ของ " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b628503800 = messageFormatterFn((function(  ) {
  return function(d) { return "ในการสร้างบัญชี ฉันได้ยอมรับ<a href=" + d["1"] + " " + d["5"] + ">ข้อกำหนดและเงื่อนไข</a> <a href=" + d["2"] + " " + d["6"] + ">นโยบายความเป็นส่วนตัว</a> และ<a href=" + d["3"] + " " + d["7"] + ">ข้อกำหนดและเงื่อนไข " + d["4"] + "</a> ของ " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1317689385 = messageFormatterFn((function(  ) {
  return function(d) { return "ฉันต้องการรับอีเมลเกี่ยวกับดีลการเดินทาง ข้อเสนอพิเศษ และข้อมูลอื่นๆ จาก " + d["0"] + " ทางอีเมล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1845859558 = messageFormatterFn((function(  ) {
  return function(d) { return "ฉันต้องการรับอีเมลเกี่ยวกับดีลการเดินทาง ข้อเสนอพิเศษ และข้อมูลอื่นๆ จาก " + d["0"] + " ทางอีเมล คุณสามารถบอกเลิกการรับอีเมลส่งเสริมการขายได้ทุกเมื่อ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1703688660 = messageFormatterFn((function(  ) {
  return function(d) { return "ฉันต้องการรับอีเมลเกี่ยวกับไอเดียการเดินทางวันหยุด ข้อเสนอพิเศษ และข้อมูลอื่นๆ จาก " + d["0"] + " ทางอีเมล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1995981763 = messageFormatterFn((function(  ) {
  return function(d) { return "ฉันต้องการรับอีเมลเกี่ยวกับไอเดียการเดินทางวันหยุด ข้อเสนอพิเศษ และข้อมูลอื่นๆ จาก " + d["0"] + " ทางอีเมล คุณสามารถบอกเลิกการรับอีเมลส่งเสริมการขายได้ทุกเมื่อ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b423360265 = messageFormatterFn((function(  ) {
  return function(d) { return "ดำเนินการต่อ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b773210756 = messageFormatterFn((function(  ) {
  return function(d) { return "มีบัญชีอยู่แล้ว? <span><a id=\"signinRedirectLink\" href=" + d["0"] + ">เข้าสู่ระบบ</a></span>"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b861830655 = messageFormatterFn((function(  ) {
  return function(d) { return "ยินดีต้อนรับ คุณ " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b2105580891 = messageFormatterFn((function(  ) {
  return function(d) { return "บัญชี " + d["0"] + " ของคุณจะเชื่อมโลกทั้งใบให้อยู่ใกล้แค่เอื้อม"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b514274386 = messageFormatterFn((function(  ) {
  return function(d) { return "ดำเนินการต่อ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b82569885 = messageFormatterFn((function(  ) {
  return function(d) { return "กรุณาตั้งรหัสผ่านที่ปลอดภัยมากขึ้นเพื่อดำเนินการต่อ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1583635752 = messageFormatterFn((function(  ) {
  return function(d) { return "ต้องมีความยาวอย่างน้อย 8 ตัว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a367860812 = messageFormatterFn((function(  ) {
  return function(d) { return "ความปลอดภัยของรหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1609207690 = messageFormatterFn((function(  ) {
  return function(d) { return "ไม่ปลอดภัย"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b2016319723 = messageFormatterFn((function(  ) {
  return function(d) { return "ปลอดภัย"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1357826283 = messageFormatterFn((function(  ) {
  return function(d) { return "ปลอดภัยมาก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b919857446 = messageFormatterFn((function(  ) {
  return function(d) { return "ไม่ควรใช้สัญลักษณ์แทนตัวอักษรที่เดาง่าย เช่น ใช้  '@' แทน 'a'"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b2046731070 = messageFormatterFn((function(  ) {
  return function(d) { return "ไม่ควรใช้คำทั่วไปโดยสะกดจากหลังไปหน้า"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b149461770 = messageFormatterFn((function(  ) {
  return function(d) { return "ควรใช้ตัวอักษรพิมพ์ใหญ่บางส่วน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b321087721 = messageFormatterFn((function(  ) {
  return function(d) { return "ควรคละตัวอักษรพิมพ์ใหญ่ไว้ที่ส่วนต่างๆ ของรหัสผ่าน ไม่เฉพาะตัวอักษรที่อยู่หน้าสุดเท่านั้น"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a95545573 = messageFormatterFn((function(  ) {
  return function(d) { return "ไม่ควรใช้วันที่และปีที่สามารถระบุตัวตนของคุณได้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1167120549 = messageFormatterFn((function(  ) {
  return function(d) { return "ไม่ควรใช้ปีที่ผ่านมาไม่นาน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1650610678 = messageFormatterFn((function(  ) {
  return function(d) { return "ไม่ควรใช้ปีที่สามารถระบุตัวตนของคุณได้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1593579191 = messageFormatterFn((function(  ) {
  return function(d) { return "ไม่ควรเรียงลำดับตัวอักษรตามที่นิยมกันทั่วไป"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a731525329 = messageFormatterFn((function(  ) {
  return function(d) { return "ไม่ควรใช้คำหรือตัวอักษรซ้ำ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1959999627 = messageFormatterFn((function(  ) {
  return function(d) { return "ควรใช้รหัสผ่านที่มีตัวอักษรหลากหลาย"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1792901030 = messageFormatterFn((function(  ) {
  return function(d) { return "ควรมีคำที่ไม่นิยมใช้ทั่วไป"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1271796410 = messageFormatterFn((function(  ) {
  return function(d) { return "ควรใช้หลายคำ แต่ไม่ควรประกอบด้วยวลีที่นิยมใช้ทั่วไป"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1224407511 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณสามารถตั้งรหัสผ่านที่ปลอดภัยโดยไม่ใช้สัญลักษณ์ ตัวเลข หรือตัวพิมพ์ใหญ่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1891142928 = messageFormatterFn((function(  ) {
  return function(d) { return "อีเมลนี้มีบัญชี" + d["0"] + "อยู่แล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1707735646 = messageFormatterFn((function(  ) {
  return function(d) { return "เราได้ส่งลิงก์ยืนยันการสร้างบัญชีให้คุณทางอีเมลแล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a2075528077 = messageFormatterFn((function(  ) {
  return function(d) { return "กำลังสร้างบัญชี"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1938444679 = messageFormatterFn((function(  ) {
  return function(d) { return "ชื่อต้องประกอบด้วยตัวอักษรภาษาอังกฤษอย่างน้อย 2 ตัวขึ้นไป"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1303169365 = messageFormatterFn((function(  ) {
  return function(d) { return "นามสกุลต้องประกอบด้วยตัวอักษรภาษาอังกฤษอย่างน้อย 2 ตัวขึ้นไป"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b690394841 = messageFormatterFn((function(  ) {
  return function(d) { return "ชื่อมีความยาวได้สูงสุด 100 ตัวอักษร"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1743748093 = messageFormatterFn((function(  ) {
  return function(d) { return "นามสกุลมีความยาวได้สูงสุด 100 ตัวอักษร"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1622769054 = messageFormatterFn((function(  ) {
  return function(d) { return "ชื่อต้องไม่ประกอบด้วยอักขระพิเศษ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b282962370 = messageFormatterFn((function(  ) {
  return function(d) { return "นามสกุลต้องไม่ประกอบด้วยอักขระพิเศษ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1823399232 = messageFormatterFn((function(  ) {
  return function(d) { return "ฉันยอมรับทุกข้อที่ระบุด้านล่างนี้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b2070113204 = messageFormatterFn((function(  ) {
  return function(d) { return "ฉันยืนยันว่าฉันอายุ 18 ปีขึ้นไป และฉันได้อ่านและยอมรับ<a href=" + d["0"] + " " + d["1"] + ">ข้อตกลงการใช้งาน</a>และ<a href=" + d["2"] + " " + d["3"] + ">" + d["4"] + "ข้อกำหนดและเงื่อนไข</a> (จำเป็นต้องระบุ)*"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1237699702 = messageFormatterFn((function(  ) {
  return function(d) { return "ฉันยินยอมให้เก็บรวบรวมและใช้ข้อมูลส่วนตัวของฉันตามที่อธิบายไว้ใน <a href=" + d["0"] + " " + d["1"] + ">นโยบายความเป็นส่วนตัว</a> (จำเป็นต้องระบุ)"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a118220695 = messageFormatterFn((function(  ) {
  return function(d) { return "ฉันยินยอมให้มอบข้อมูลส่วนตัวของฉันแก่บุคคลภายนอก ไม่ว่าจะในเกาหลีหรือประเทศอื่นๆ ตามที่อธิบายไว้ใน <a href=" + d["0"] + " " + d["1"] + ">นโยบายความเป็นส่วนตัว</a> (จำเป็นต้องระบุ)"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a407616340 = messageFormatterFn((function(  ) {
  return function(d) { return "กรุณายอมรับข้อกำหนดเพื่อดำเนินการต่อ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1350449968 = messageFormatterFn((function(  ) {
  return function(d) { return "ยอมรับข้อกำหนดเพื่อดำเนินการต่อ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b75336500 = messageFormatterFn((function(  ) {
  return function(d) { return "ทำเครื่องหมายที่ช่องเพื่อดำเนินการต่อ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a359820741 = messageFormatterFn((function(  ) {
  return function(d) { return "หรือสร้างบัญชีกับ " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b395829031 = messageFormatterFn((function(  ) {
  return function(d) { return "หลีกเลี่ยงการเว้นวรรค ชื่อ อีเมล หรือรหัสผ่านที่คุณเคยใช้ก่อนหน้านี้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a148835747 = messageFormatterFn((function(  ) {
  return function(d) { return "ขออภัย เกิดข้อผิดพลาดในระบบ โปรดรอสักครู่แล้วลองอีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1287681975 = messageFormatterFn((function(  ) {
  return function(d) { return "ยืนยันหมายเลขโทรศัพท์มือถือของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1915277562 = messageFormatterFn((function(  ) {
  return function(d) { return "เราจะส่งรหัสยืนยันไปยังหมายเลขโทรศัพท์มือถือของคุณในแต่ละครั้งเพื่อรักษาความปลอดภัยของบัญชี"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1626069715 = messageFormatterFn((function(  ) {
  return function(d) { return "ส่ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1698449594 = messageFormatterFn((function(  ) {
  return function(d) { return "© " + d["1"] + " " + d["0"] + " สงวนสิทธิ์ทุกประการ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a219067400 = messageFormatterFn((function(  ) {
  return function(d) { return "ข้อกำหนดและเงื่อนไข"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a737359945 = messageFormatterFn((function(  ) {
  return function(d) { return "นโยบายความเป็นส่วนตัว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a441324320 = messageFormatterFn((function(  ) {
  return function(d) { return "ส่งรหัสทางข้อความ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a749080821 = messageFormatterFn((function(  ) {
  return function(d) { return "ป้อนรหัสยืนยัน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1095693991 = messageFormatterFn((function(  ) {
  return function(d) { return "รหัสยืนยัน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b471146342 = messageFormatterFn((function(  ) {
  return function(d) { return "ส่งรหัสอีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b642463951 = messageFormatterFn((function(  ) {
  return function(d) { return "เปลี่ยนหมายเลขโทรศัพท์มือถือ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1719063389 = messageFormatterFn((function(  ) {
  return function(d) { return "ส่งรหัสยืนยันให้อีกครั้งแล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1607562884 = messageFormatterFn((function(  ) {
  return function(d) { return "ป้อนรหัสยืนยัน 6 หลักที่เราได้ส่งไปยัง " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b795482039 = messageFormatterFn((function(  ) {
  return function(d) { return "กำลังตรวจสอบรหัสยืนยัน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b667374370 = messageFormatterFn((function(  ) {
  return function(d) { return "รหัสไม่ถูกต้อง ส่งรหัสเพื่อลองใหม่อีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1128815320 = messageFormatterFn((function(  ) {
  return function(d) { return "หรือเข้าสู่ระบบด้วย"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1885027528 = messageFormatterFn((function(  ) {
  return function(d) { return "สมาชิกจะได้รับส่วนลดเพิ่มโดยเฉลี่ยอีก " + d["0"] + "% จากหลายพันโรงแรมที่ร่วมรายการ สมัครฟรีได้ตลอดเวลา"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a683436742 = messageFormatterFn((function(  ) {
  return function(d) { return "หรือ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1058240068 = messageFormatterFn((function(  ) {
  return function(d) { return "เข้าสู่ระบบโดยวิธีอื่น"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1058599482 = messageFormatterFn((function(  ) {
  return function(d) { return "สมัครสมาชิกโดยวิธีอื่น"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b768260528 = messageFormatterFn((function(  ) {
  return function(d) { return "สมัครด้วย Google"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b828701137 = messageFormatterFn((function(  ) {
  return function(d) { return "เข้าสู่ระบบไม่สำเร็จ ลองอีกครั้งหรือสร้างบัญชีเพื่อเข้าสู่ระบบ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a748027049 = messageFormatterFn((function(  ) {
  return function(d) { return "การเข้าสู่ระบบด้วยหมายเลขโทรศัพท์ไม่สามารถใช้งานได้ ตรวจดูให้แน่ใจว่าได้ตั้งค่าบัญชีโซเชียลของคุณให้แชร์อีเมลของคุณได้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1406555041 = messageFormatterFn((function(  ) {
  return function(d) { return "สมาชิกจะได้รับส่วนลดขั้นต่ำ " + d["0"] + "% จากหลายพันโรงแรมที่ร่วมรายการ สมัครฟรีได้ตลอดเวลา"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1192960646 = messageFormatterFn((function(  ) {
  return function(d) { return "เข้าสู่ระบบด้วย Google"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1277566789 = messageFormatterFn((function(  ) {
  return function(d) { return "เข้าสู่ระบบด้วย NAVER"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a486173733 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณพยายามเข้าสู่ระบบเกินจำนวนครั้งที่กำหนด โปรดลองใหม่ภายหลัง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a2043252984 = messageFormatterFn((function(  ) {
  return function(d) { return "เข้าสู่ระบบด้วยอัตลักษณ์บุคคล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1585500200 = messageFormatterFn((function(  ) {
  return function(d) { return "ใช้อัตลักษณ์บุคคลเพื่อเข้าถึงบัญชี และไม่ต้องพิมพ์รหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b745340011 = messageFormatterFn((function(  ) {
  return function(d) { return "เริ่มใช้งาน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b437561477 = messageFormatterFn((function(  ) {
  return function(d) { return "เตือนฉันภายหลัง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b165728977 = messageFormatterFn((function(  ) {
  return function(d) { return "สำเร็จ!"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1976169877 = messageFormatterFn((function(  ) {
  return function(d) { return "เปิดใช้งานการเข้าสู่ระบบด้วยอัตลักษณ์บุคคลแล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1518098259 = messageFormatterFn((function(  ) {
  return function(d) { return "เข้าสู่ระบบด้วยอัตลักษณ์บุคคล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a712699096 = messageFormatterFn((function(  ) {
  return function(d) { return "ใช้รหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a165510141 = messageFormatterFn((function(  ) {
  return function(d) { return "ใช้อัตลักษณ์บุคคล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a478305834 = messageFormatterFn((function(  ) {
  return function(d) { return "อัปเดตรหัสผ่านของคุณแล้วดำเนินการต่อ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1748821138 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณต้องตั้งรหัสผ่านใหม่ก่อนเข้าบัญชีของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1988339128 = messageFormatterFn((function(  ) {
  return function(d) { return "รีเซ็ตรหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b352902072 = messageFormatterFn((function(  ) {
  return function(d) { return "ยินดีต้อนรับสู่สิทธิประโยชน์สำหรับสมาชิก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1562028910 = messageFormatterFn((function(  ) {
  return function(d) { return "เริ่มต้นการเดินทางครั้งใหม่ของคุณด้วยของขวัญจากเราในรูปแบบคะแนนสะสมมูลค่า $" + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1601489794 = messageFormatterFn((function(  ) {
  return function(d) { return "คะแนนนี้ได้ปรากฏในบัญชีของคุณและพร้อมให้นำมาใช้กับการจองครั้งแรกได้เลย อย่าลืมมองหาตัวเลือกใช้คะแนนที่หน้าชำระเงิน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1319253584 = messageFormatterFn((function(  ) {
  return function(d) { return "ขณะนี้คุณเป็นสมาชิกเอ็กซ์พีเดียแล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1818921600 = messageFormatterFn((function(  ) {
  return function(d) { return "เริ่มต้นออกเดินทางอย่างคุ้มค่าได้ทันทีด้วยราคาสมาชิก และรับคะแนนสะสมเมื่อทำการจอง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1614784117 = messageFormatterFn((function(  ) {
  return function(d) { return "เข้าสู่ระบบหรือสร้างบัญชี"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a653378629 = messageFormatterFn((function(  ) {
  return function(d) { return "สมาชิกจะได้รับส่วนลดเพิ่มโดยเฉลี่ยอีก " + d["0"] + "% จากหลายพันโรงแรมที่ร่วมรายการ สมัครฟรีได้ตลอดเวลา"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1888947363 = messageFormatterFn((function(  ) {
  return function(d) { return "โดยการดำเนินการต่อไป คุณได้อ่านและยอมรับ<a href=" + d["1"] + " " + d["3"] + ">ข้อกำหนดและเงื่อนไข</a>และ<a href=" + d["2"] + " " + d["4"] + ">นโยบายความเป็นส่วนตัว</a>ของเรา"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1790245925 = messageFormatterFn((function(  ) {
  return function(d) { return "โดยการดำเนินการต่อไป คุณได้อ่านและยอมรับ<a href=" + d["1"] + " " + d["5"] + ">ข้อกำหนดและเงื่อนไข</a>และ<a href=" + d["2"] + " " + d["6"] + ">นโยบายความเป็นส่วนตัว</a>ของเรา และ<a href=" + d["3"] + " " + d["7"] + ">ข้อกำหนดและเงื่อนไขของ " + d["4"] + "</a>"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b194918016 = messageFormatterFn((function(  ) {
  return function(d) { return "โดยการดำเนินการต่อไป คุณได้อ่านและยอมรับ<a href=" + d["1"] + " " + d["4"] + ">ข้อกำหนดและเงื่อนไข</a> <a href=" + d["2"] + " " + d["5"] + ">นโยบายความเป็นส่วนตัว</a>ของเรา และ<a href=" + d["3"] + " " + d["6"] + ">ข้อกำหนดและเงื่อนไขของโปรแกรมสมาชิก One Key</a>"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1164987804 = messageFormatterFn((function(  ) {
  return function(d) { return "อีเมล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b131216482 = messageFormatterFn((function(  ) {
  return function(d) { return "ป้อนอีเมลที่ถูกต้อง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a578881185 = messageFormatterFn((function(  ) {
  return function(d) { return "Google"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a496467118 = messageFormatterFn((function(  ) {
  return function(d) { return "Facebook"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b566046328 = messageFormatterFn((function(  ) {
  return function(d) { return "Apple"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1711027999 = messageFormatterFn((function(  ) {
  return function(d) { return "สำหรับอุปกรณ์ส่วนตัวเท่านั้น โปรดอย่าเลือกตัวเลือกนี้บนอุปกรณ์ที่ใช้ร่วมกับผู้อื่นเพื่อรักษาความปลอดภัยของบัญชี"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a2087123246 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณพยายามเข้าสู่ระบบหลายครั้งเกินไป กรุณารอ " + d["0"] + " นาทีแล้วลองใหม่อีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1858536438 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณพยายามเข้าสู่ระบบหลายครั้งเกินไป กรุณารอ " + d["0"] + " นาทีแล้วลองใหม่อีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1863431772 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณพยายามเข้าสู่ระบบหลายครั้งเกินไป กรุณารอ " + d["0"] + " นาทีแล้วลองใหม่อีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1849973928 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณพยายามเข้าสู่ระบบหลายครั้งเกินไป กรุณารอ " + d["0"] + " นาทีแล้วลองใหม่อีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1711140645 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณพยายามเข้าสู่ระบบหลายครั้งเกินไป กรุณารอ " + d["0"] + " นาทีแล้วลองใหม่อีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b476315424 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณพยายามเข้าสู่ระบบหลายครั้งเกินไป กรุณารอ " + d["0"] + " นาทีแล้วลองใหม่อีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1680542415 = messageFormatterFn((function(  ) {
  return function(d) { return "ปลดล็อกสิทธิประโยชน์มากมายในบัญชีเดียวกับเอ็กซ์พีเดีย, Hotels.com และ Vrbo"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b947765111 = messageFormatterFn((function(  ) {
  return function(d) { return "ปลดล็อกโลกแห่งการเดินทางในบัญชีเดียวกับเอ็กซ์พีเดีย, Hotels.com และ Vrbo"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a774022928 = messageFormatterFn((function(  ) {
  return function(d) { return "ค้นหาและบันทึกที่พัก วางแผนกับเพื่อนร่วมทริป และเข้าถึงรายละเอียดการจองของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1019909903 = messageFormatterFn((function(  ) {
  return function(d) { return "บัญชีของคุณถูกระงับชั่วคราวหลังการตรวจสอบความปลอดภัยตามปกติ ข้อมูลของคุณปลอดภัยดี แต่คุณจำเป็นต้องตั้งรหัสผ่านใหม่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1798965887 = messageFormatterFn((function(  ) {
  return function(d) { return "เข้าสู่ระบบและจองที่พักของคุณเพื่อรับ OneKeyCash"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a735870707 = messageFormatterFn((function(  ) {
  return function(d) { return "กรุณายืนยันตัวตนของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b935382265 = messageFormatterFn((function(  ) {
  return function(d) { return "กรอกรหัสความปลอดภัยที่คุณได้รับทางอีเมล หากไม่พบอีเมลในกล่องจดหมาย กรุณาตรวจสอบที่โฟลเดอร์ขยะ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1167649029 = messageFormatterFn((function(  ) {
  return function(d) { return "ยืนยันอีเมลของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1254443083 = messageFormatterFn((function(  ) {
  return function(d) { return "กรอกรหัสความปลอดภัยที่เราส่งไปที่ " + d["0"] + " เพื่อดำเนินการต่อ หากไม่พบอีเมลในกล่องจดหมาย กรุณาตรวจสอบที่โฟลเดอร์ขยะ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1900596017 = messageFormatterFn((function(  ) {
  return function(d) { return "รหัส 6 หลัก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a396944945 = messageFormatterFn((function(  ) {
  return function(d) { return "ส่งรหัสอีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a193961928 = messageFormatterFn((function(  ) {
  return function(d) { return "(0:" + d["0"] + ")"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1948394768 = messageFormatterFn((function(  ) {
  return function(d) { return "ส่งรหัสอีกครั้งใน " + d["0"] + " วินาที"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1001575072 = messageFormatterFn((function(  ) {
  return function(d) { return "ไม่ได้รับอีเมล?"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1829115070 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณสามารถขอรหัสใหม่ได้ใน " + d["0"] + " วินาที"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b462818005 = messageFormatterFn((function(  ) {
  return function(d) { return "ขอรหัสความปลอดภัยใหม่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a557770741 = messageFormatterFn((function(  ) {
  return function(d) { return "เราได้ส่งรหัสใหม่ 6 หลักไปที่อีเมลของคุณแล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a673205760 = messageFormatterFn((function(  ) {
  return function(d) { return "ป้อนรหัสผ่านแทน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1434237121 = messageFormatterFn((function(  ) {
  return function(d) { return "รหัสไม่ถูกต้อง โปรดลองอีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a325738479 = messageFormatterFn((function(  ) {
  return function(d) { return "รหัสหมดอายุแล้ว โปรดส่งใหม่และลองอีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a764523364 = messageFormatterFn((function(  ) {
  return function(d) { return "หากไม่พบอีเมลในกล่องจดหมาย กรุณาตรวจสอบที่โฟลเดอร์ขยะ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1253874485 = messageFormatterFn((function(  ) {
  return function(d) { return "เราได้ทำการอัปเดตประสบการณ์การใช้งานและจำเป็นต้องยืนยันอีเมลของคุณ กรอกรหัสความปลอดภัยที่คุณได้รับทางอีเมล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a2012181076 = messageFormatterFn((function(  ) {
  return function(d) { return "เกิดข้อผิดพลาดในระบบ โปรดลองอีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a632902429 = messageFormatterFn((function(  ) {
  return function(d) { return "กรอกรหัสความปลอดภัยที่คุณได้รับทางอีเมลเพื่ออัปเดตวิธีเข้าสู่ระบบของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b822918071 = messageFormatterFn((function(  ) {
  return function(d) { return "ป้อนรหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a994398594 = messageFormatterFn((function(  ) {
  return function(d) { return "ส่งรหัสความปลอดภัยทางอีเมล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a585905310 = messageFormatterFn((function(  ) {
  return function(d) { return "อีเมลและรหัสผ่านไม่ตรงกัน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1988993177 = messageFormatterFn((function(  ) {
  return function(d) { return "ตั้งรหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a669133276 = messageFormatterFn((function(  ) {
  return function(d) { return "สร้างรหัสผ่าน | " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1765548945 = messageFormatterFn((function(  ) {
  return function(d) { return "ตั้งรหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b447422039 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณสามารถใช้อีเมลและรหัสผ่านเดียวกันเข้าสู่ระบบเอ็กซ์พีเดีย, Hotels.com และ Vrbo ได้ทั้งหมด"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1683026217 = messageFormatterFn((function(  ) {
  return function(d) { return "ตั้งรหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b386863962 = messageFormatterFn((function(  ) {
  return function(d) { return "ตั้งรหัสผ่านเพื่อใช้งานนอกเหนือจากการเข้าสู่ระบบอย่างปลอดภัยวิธีอื่นๆ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a896828635 = messageFormatterFn((function(  ) {
  return function(d) { return "ตั้งรหัสผ่านใหม่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1879430120 = messageFormatterFn((function(  ) {
  return function(d) { return "ตั้งรหัสผ่านใหม่ | " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a491437061 = messageFormatterFn((function(  ) {
  return function(d) { return "ตั้งรหัสผ่านใหม่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1406403765 = messageFormatterFn((function(  ) {
  return function(d) { return "ตอนนี้คุณสามารถใช้บัญชีเดียวเข้าสู่ระบบเอ็กซ์พีเดีย, Hotels.com และ Vrbo ได้ทั้งหมด ตั้งรหัสผ่านใหม่ที่ปลอดภัยสำหรับบัญชีรวมของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a952008779 = messageFormatterFn((function(  ) {
  return function(d) { return "ตั้งรหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1142880957 = messageFormatterFn((function(  ) {
  return function(d) { return "เปลี่ยนรหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1854160070 = messageFormatterFn((function(  ) {
  return function(d) { return "เปลี่ยนรหัสผ่าน | " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a135392275 = messageFormatterFn((function(  ) {
  return function(d) { return "ใช้รหัสผ่านที่ไม่ซ้ำและคาดเดาได้ยาก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a680391725 = messageFormatterFn((function(  ) {
  return function(d) { return "อัปเดตรหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b499455974 = messageFormatterFn((function(  ) {
  return function(d) { return "เราไม่สามารถเปลี่ยนรหัสผ่านของคุณ โปรดลองอีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a929833144 = messageFormatterFn((function(  ) {
  return function(d) { return "ลืมรหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a668565282 = messageFormatterFn((function(  ) {
  return function(d) { return "ป้อนอีเมลของคุณ แล้วเราจะส่งรหัสความปลอดภัยเพื่อเข้าสู่ระบบ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1648382654 = messageFormatterFn((function(  ) {
  return function(d) { return "ส่งอีเมล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b171765238 = messageFormatterFn((function(  ) {
  return function(d) { return "ติดต่อเรา"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b451752411 = messageFormatterFn((function(  ) {
  return function(d) { return "ลบข้อมูล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1496334054 = messageFormatterFn((function(  ) {
  return function(d) { return "ปิด"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1173478594 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดรอสักครู่ขณะที่เราตรวจสอบบัญชีของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b81972159 = messageFormatterFn((function(  ) {
  return function(d) { return "ลบบัญชี"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1767631781 = messageFormatterFn((function(  ) {
  return function(d) { return "ตกลง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b606764033 = messageFormatterFn((function(  ) {
  return function(d) { return "ขออภัย คุณยังไม่สามารถลบบัญชีได้จนกว่าการเดินทางที่จองไว้จะเสร็จสิ้น"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1549502752 = messageFormatterFn((function(  ) {
  return function(d) { return "เนื่องจากคุณต้องเข้าสู่ระบบบัญชีเพื่อดูข้อมูลการจอง  หรือติดต่อเจ้าหน้าที่ในกรณีที่จำเป็นต้องเปลี่ยนแปลงการจองกะทันหัน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b464192845 = messageFormatterFn((function(  ) {
  return function(d) { return "ขออภัย คุณจะต้องลบบัญชีเจ้าของที่พัก Vrbo ของคุณก่อน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1702770084 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดไปที่ศูนย์ช่วยเหลือของเราบนเว็บไซต์หรือแอป แล้วติดต่อฝ่ายบริการลูกค้าโดยตรงเพื่อเริ่มขั้นตอนนี้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a592896980 = messageFormatterFn((function(  ) {
  return function(d) { return "กรุณาลองอีกครั้งเมื่อทริปสิ้นสุด"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a2121170417 = messageFormatterFn((function(  ) {
  return function(d) { return "สาเหตุที่ต้องการลบบัญชี"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b218888322 = messageFormatterFn((function(  ) {
  return function(d) { return "ฉันได้รับอีเมลหรือการแจ้งเตือนเยอะเกินไป"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b786350316 = messageFormatterFn((function(  ) {
  return function(d) { return "ฉันมีบัญชี " + d["0"] + " อยู่อีกบัญชีหนึ่ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b138703793 = messageFormatterFn((function(  ) {
  return function(d) { return "เดินทางเรียบร้อยแล้ว จึงไม่ต้องการใช้บัญชีนี้อีก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b941385259 = messageFormatterFn((function(  ) {
  return function(d) { return "ฉันมีประสบการณ์ที่ไม่ดีในการจองกับ " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b566275990 = messageFormatterFn((function(  ) {
  return function(d) { return "อื่นๆ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1898826515 = messageFormatterFn((function(  ) {
  return function(d) { return "ข้าม"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1641845466 = messageFormatterFn((function(  ) {
  return function(d) { return "ส่ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1777856022 = messageFormatterFn((function(  ) {
  return function(d) { return "เราเสียใจที่คุณต้องไป ต่อไปนี้คือข้อควรทราบเมื่อคุณลบบัญชี"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b188991005 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณจะไม่สามารถใช้งาน Expedia Rewards " + d["0"] + " คะแนน มูลค่า " + d["1"] + ", เครดิตมูลค่า " + d["2"] + ", คูปอง, รายการการเดินทางที่บันทึกไว้ และการตั้งค่าบัญชีได้อีก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1415781522 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณจะไม่สามารถใช้งาน Expedia Rewards " + d["0"] + " คะแนน มูลค่า " + d["1"] + ", คูปอง, รายการการเดินทางที่บันทึกไว้ และการตั้งค่าบัญชีได้อีก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1743803920 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณจะไม่สามารถใช้งานการเดินทาง เครดิต และการตั้งค่าได้อีก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1542057306 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards: คุณจะไม่สามารถใช้งานคืนเข้าพัก " + d["0"] + " คืน มูลค่า " + d["1"] + ", และแสตมป์ " + d["2"] + " ดวง มูลค่าเฉลี่ย " + d["3"] + " ได้อีก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a291997111 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณจะไม่สามารถใช้งานเครดิต คูปอง รายการการเดินทางที่บันทึกไว้ และการตั้งค่าบัญชีได้อีก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1312510625 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณจะไม่สามารถใช้งาน CheapCash " + d["0"] + " คะแนน มูลค่า " + d["1"] + ", เครดิตมูลค่า " + d["2"] + ", คูปอง รายการการเดินทางที่บันทึกไว้ และการตั้งค่าบัญชีได้อีก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b2132104590 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณจะไม่สามารถใช้งาน CheapCash " + d["0"] + " คะแนน มูลค่า " + d["1"] + ", คูปอง, รายการการเดินทางที่บันทึกไว้ และการตั้งค่าบัญชีได้อีก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b76161385 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณจะไม่สามารถใช้งาน Orbucks " + d["0"] + " คะแนน มูลค่า " + d["1"] + ", เครดิตมูลค่า " + d["2"] + ", คูปอง, รายการการเดินทางที่บันทึกไว้ และการตั้งค่าบัญชีได้อีก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1642265030 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณจะไม่สามารถใช้งาน Orbucks " + d["0"] + " คะแนน มูลค่า " + d["1"] + ", คูปอง, รายการการเดินทางที่บันทึกไว้ และการตั้งค่าบัญชีได้อีก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1908745181 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณจะไม่สามารถใช้งาน MrJet Rewards " + d["0"] + " คะแนน มูลค่า " + d["1"] + ", เครดิตมูลค่า " + d["2"] + ", คูปอง, รายการการเดินทางที่บันทึกไว้ และการตั้งค่าบัญชีได้อีก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a778983726 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณจะไม่สามารถใช้งาน MrJet Rewards " + d["0"] + " คะแนน มูลค่า " + d["1"] + ", คูปอง, รายการการเดินทางที่บันทึกไว้ และการตั้งค่าบัญชีได้อีก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1714876929 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณจะไม่สามารถใช้งาน BONUS+ " + d["0"] + " คะแนน มูลค่า " + d["1"] + ", เครดิตมูลค่า " + d["2"] + ", คูปอง, รายการการเดินทางที่บันทึกไว้ และการตั้งค่าบัญชีได้อีก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1687050798 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณจะไม่สามารถใช้งาน BONUS+ " + d["0"] + " คะแนน มูลค่า " + d["1"] + ", คูปอง, รายการการเดินทางที่บันทึกไว้ และการตั้งค่าบัญชีได้อีก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a333245577 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณจะไม่สามารถใช้งานคูปอง รายการการเดินทางที่บันทึกไว้ และการตั้งค่าบัญชีได้อีก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a45612382 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณจะไม่สามารถใช้งานเครดิตมูลค่า " + d["0"] + ", คูปอง, รายการการเดินทางที่บันทึกไว้ และการตั้งค่าบัญชีได้อีก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1770845720 = messageFormatterFn((function(  ) {
  return function(d) { return "เราอาจจัดเก็บข้อมูลบางอย่างของคุณไว้โดยใช้มาตรการจัดเก็บอย่างปลอดภัยเพื่อให้เป็นไปตามข้อกำหนดทางกฎหมาย เช่น บันทึกการทำธุรกรรม หรือในกรณีที่เราจำเป็นต้องสร้าง ใช้ หรือโต้แย้งข้อเรียกร้องทางกฎหมาย เราจะจัดเก็บข้อมูลนี้ไว้อย่างปลอดภัย โดยเราจะดำเนินการลบ ปิดบังตัวตน หรือทำให้ไม่สามารถนำมาใช้ได้อย่างถาวรเมื่อไม่มีความจำเป็นต้องใช้ข้อมูลนี้อีกต่อไป"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1922017748 = messageFormatterFn((function(  ) {
  return function(d) { return "ลบบัญชีถาวร"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b691760036 = messageFormatterFn((function(  ) {
  return function(d) { return "ไม่ลบบัญชี"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b494645550 = messageFormatterFn((function(  ) {
  return function(d) { return "เราหวังว่าจะมีโอกาสได้ให้บริการคุณอีก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1177822989 = messageFormatterFn((function(  ) {
  return function(d) { return "คำขอลบบัญชีของคุณอาจใช้เวลาสองสามสัปดาห์ในการดำเนินการ ดังนั้น คุณอาจยังได้รับการติดต่อสื่อสารจากเราในระหว่างที่ระบบกำลังอัปเดตข้อมูล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1797198285 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดลองอีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1045270260 = messageFormatterFn((function(  ) {
  return function(d) { return "เกิดข้อผิดพลาด โปรดส่งคำขอลบบัญชีของคุณอีกครั้ง หรือรอสักครู่แล้วลองใหม่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b375862468 = messageFormatterFn((function(  ) {
  return function(d) { return "ปิด"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a945390869 = messageFormatterFn((function(  ) {
  return function(d) { return "ชื่อของคุณบนเอกสารการเดินทาง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1046399387 = messageFormatterFn((function(  ) {
  return function(d) { return "ระบุชื่อบัญชีของคุณให้ตรงกับเอกสารที่คุณใช้ในการเดินทาง เช่น หนังสือเดินทางหรือบัตรประจำตัวประชาชน เราจะบันทึกข้อมูลไว้สำหรับการจองครั้งต่อไป"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b74538615 = messageFormatterFn((function(  ) {
  return function(d) { return "รับดีล ข้อเสนอ และข้อมูลอื่นๆ จาก " + d["0"] + " ทางอีเมล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b114587770 = messageFormatterFn((function(  ) {
  return function(d) { return "รับดีล ข้อเสนอ และข้อมูลอื่นๆ จาก " + d["0"] + " ทางอีเมล คุณสามารถเลือกที่จะไม่รับอีเมลการตลาดได้ทุกเมื่อ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b2110192831 = messageFormatterFn((function(  ) {
  return function(d) { return "ข้อมูลบัญชี"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1058113086 = messageFormatterFn((function(  ) {
  return function(d) { return "ข้อมูลบัญชี | " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1457172055 = messageFormatterFn((function(  ) {
  return function(d) { return "รับอีเมลเกี่ยวกับดีล ข้อเสนอ และข้อมูลอื่นๆ จาก " + d["0"] + " คุณสามารถยกเลิกการเข้าร่วมได้ตลอดเวลา"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a404007317 = messageFormatterFn((function(  ) {
  return function(d) { return "รวมบัญชี | " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b333593869 = messageFormatterFn((function(  ) {
  return function(d) { return "ทันทุกข่าวสารการเดินทาง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b330993901 = messageFormatterFn((function(  ) {
  return function(d) { return "ความยินยอมทางการตลาด"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1155689694 = messageFormatterFn((function(  ) {
  return function(d) { return "Expedia Rewards"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a181683072 = messageFormatterFn((function(  ) {
  return function(d) { return "CheapCash"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1693770104 = messageFormatterFn((function(  ) {
  return function(d) { return "Orbitz Rewards"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1617765216 = messageFormatterFn((function(  ) {
  return function(d) { return "BONUS+"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1196390690 = messageFormatterFn((function(  ) {
  return function(d) { return "MrJet"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a227874183 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b744472667 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1041228078 = messageFormatterFn((function(  ) {
  return function(d) { return "ขออภัย คุณต้องรอจนกว่าจะจบทริป"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1866991554 = messageFormatterFn((function(  ) {
  return function(d) { return "ขออภัย คุณต้องรอจนกว่าจะจบทริปที่กำลังจะมาถึง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a2087422396 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณสามารถใช้บัญชีเข้าถึงรายละเอียดการจองและความช่วยเหลือได้ กรุณาลองอีกครั้งเมื่อทริปสิ้นสุด"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1197295576 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณสามารถใช้บัญชีเข้าถึงรายละเอียดการจองและความช่วยเหลือได้ กรุณาลองอีกครั้งเมื่อทริปสิ้นสุด"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1973066847 = messageFormatterFn((function(  ) {
  return function(d) { return "ขออภัย ไม่สามารถลบบัญชีของคุณได้ในขณะนี้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1872468597 = messageFormatterFn((function(  ) {
  return function(d) { return "มีการใช้บัญชีนี้เป็นผู้ให้บริการที่พักบน Vrbo ด้วย ก่อนที่คุณจะลบบัญชี คุณต้องเข้าสู่ระบบในแอปหรือเว็บไซต์ Vrbo Owner เพื่อลบที่พักที่ลงรายการไว้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a63855428 = messageFormatterFn((function(  ) {
  return function(d) { return "ก่อนจากกันไปบอกเราสักหน่อยว่าเพราะเหตุใด"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b685345241 = messageFormatterFn((function(  ) {
  return function(d) { return "ฉันมีอีกบัญชีในอีเมลอื่น"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a114293800 = messageFormatterFn((function(  ) {
  return function(d) { return "ฉันมีประสบการณ์ที่ไม่ดีในการจอง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b325234563 = messageFormatterFn((function(  ) {
  return function(d) { return "เราเสียใจที่คุณต้องไป โปรดทราบว่าจะไม่สามารถกู้บัญชีที่ลบไปแล้วกลับคืนมาได้ และจะมีผลต่อข้อมูลบนเอ็กซ์พีเดีย, Hotels.com และ Vrbo ต่อไปนี้คือข้อควรทราบเมื่อคุณลบบัญชี"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a196751240 = messageFormatterFn((function(  ) {
  return function(d) { return "เราเสียใจที่คุณต้องไป โปรดทราบว่าจะไม่สามารถกู้บัญชีที่ลบไปแล้วกลับคืนมาได้ และจะมีผลต่อข้อมูลบนเอ็กซ์พีเดีย, Wotif, Hotels.com และ Vrbo ต่อไปนี้คือข้อควรทราบเมื่อคุณลบบัญชี"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1626590623 = messageFormatterFn((function(  ) {
  return function(d) { return "ประวัติการใช้งานบัญชี การตั้งค่า และรายการที่บันทึกในเอ็กซ์พีเดีย, Hotels.com and Vrbo ของคุณจะหายไปตลอดกาลโดยไม่สามารถกู้คืนได้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b653079766 = messageFormatterFn((function(  ) {
  return function(d) { return "ประวัติการใช้งานบัญชี การตั้งค่า และรายการที่บันทึกในเอ็กซ์พีเดีย, Wotif, Hotels.com และ Vrbo ของคุณจะหายไปตลอดกาลโดยไม่สามารถกู้คืนได้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a248135827 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณจะเสีย OneKeyCash ของคุณทั้งหมด รวมถึง OneKeyCash ที่รอดำเนินการใดๆ และเสียสิทธิพิเศษของระดับสมาชิก One Key โดยไม่สามารถกู้คืนได้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1737308169 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณจะเสีย OneKeyCash ที่รอดำเนินการใดๆ ทั้งหมด และเสียสิทธิพิเศษของระดับสมาชิก One Key  โดยไม่สามารถกู้คืนได้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b274911230 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณจะเสีย " + d["0"] + " OneKeyCash และ OneKeyCash ที่รอดำเนินการใดๆ และเสียสิทธิพิเศษของระดับสมาชิก One Key  โดยไม่สามารถกู้คืนได้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a567290644 = messageFormatterFn((function(  ) {
  return function(d) { return "ผู้ถือบัตรเครดิต Hotels.com Rewards จะไม่สามารถรับรางวัลจากการใช้บัตรได้อีกต่อไป"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b295773199 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณจะเสียคะแนน Expedia Rewards ทั้งหมด รวมถึงเสียคะแนน Expedia Rewards, แสตมป์ Hotels.com Rewards, คืนเข้าพัก Rewards, และระดับสมาชิก Rewards ทั้งที่ยืนยันแล้วและรอดำเนินการ โดยไม่สามารถกู้คืนได้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1253234585 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณจะเสียคะแนน Expedia Rewards, แสตมป์ Hotels.com Rewards, คืนเข้าพัก Rewards, และระดับสมาชิก Rewards ที่รอดำเนินการ โดยไม่สามารถกู้คืนได้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1729750637 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณจะเสียคูปองและเครดิตของเอ็กซ์พีเดีย, Hotels.com, หรือ Vrbo โดยไม่สามารถกู้คืนได้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1368035704 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณจะเสียคูปองและเครดิตของเอ็กซ์พีเดีย, Wotif, Hotels.com, หรือ Vrbo โดยไม่สามารถกู้คืนได้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b968364858 = messageFormatterFn((function(  ) {
  return function(d) { return "คำขอลบบัญชีเอ็กซ์พีเดีย, Hotels.com และ Vrbo ของคุณอาจใช้เวลาสองสามสัปดาห์ในการดำเนินการ ดังนั้น คุณอาจยังได้รับการติดต่อสื่อสารจากเราในระหว่างที่ระบบกำลังอัปเดตข้อมูล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b542723823 = messageFormatterFn((function(  ) {
  return function(d) { return "คำขอลบบัญชีเอ็กซ์พีเดีย, Wotif, Hotels.com และ Vrbo ของคุณอาจใช้เวลาสองสามสัปดาห์ในการดำเนินการ ดังนั้น คุณอาจยังได้รับการติดต่อสื่อสารจากเราในระหว่างที่ระบบกำลังอัปเดตข้อมูล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a29548859 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key Card ของคุณจะปิดเมื่อคุณลบบัญชีของคุณ และคุณจะไม่ได้รับ OneKeyCash จากการจองอีกต่อไป Wells Fargo จะติดต่อไปพร้อมการยืนยันการปิดบัตรของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b246335537 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key+ Card ของคุณจะปิดเมื่อคุณลบบัญชีของคุณ และคุณจะไม่ได้รับ OneKeyCash จากการจองอีกต่อไป Wells Fargo จะติดต่อไปพร้อมการยืนยันการปิดบัตรของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b732584260 = messageFormatterFn((function(  ) {
  return function(d) { return "เข้าสู่ระบบหรือสร้างบัญชีเพื่อรับ OneKeyCash สำหรับทริปของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1231377566 = messageFormatterFn((function(  ) {
  return function(d) { return "เข้าสู่ระบบหรือสร้างบัญชีเพื่อรับรีวอร์ดสำหรับการเข้าพักนี้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1563291963 = messageFormatterFn((function(  ) {
  return function(d) { return "ชำระเงินโดยไม่เข้าสู่ระบบ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1107807053 = messageFormatterFn((function(  ) {
  return function(d) { return "เข้าสู่ระบบบัญชี " + d["0"] + ": เพิ่มเบอร์มือถือ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1911975907 = messageFormatterFn((function(  ) {
  return function(d) { return "เกิดข้อผิดพลาด"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1853968137 = messageFormatterFn((function(  ) {
  return function(d) { return "กรุณาลองเข้าสู่ระบบอีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1857892864 = messageFormatterFn((function(  ) {
  return function(d) { return "ตกลง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a939747769 = messageFormatterFn((function(  ) {
  return function(d) { return "โลโก้ " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a223610700 = messageFormatterFn((function(  ) {
  return function(d) { return "รวมบัญชี"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b698926408 = dateToPartsFormatterFn({"2":Globalize("th-TH").numberFormatter({"raw":"00"}),"4":Globalize("th-TH").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.b1813472776 = dateToPartsFormatterFn({"2":Globalize("th-TH").numberFormatter({"raw":"00"}),"4":Globalize("th-TH").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.b1522686901 = dateToPartsFormatterFn({"1":Globalize("th-TH").numberFormatter({"raw":"0"}),"4":Globalize("th-TH").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.a1649826437 = dateToPartsFormatterFn({"1":Globalize("th-TH").numberFormatter({"raw":"0"}),"4":Globalize("th-TH").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.b1759331752 = dateToPartsFormatterFn({"2":Globalize("th-TH").numberFormatter({"raw":"00"}),"4":Globalize("th-TH").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.a1225983565 = dateToPartsFormatterFn({"1":Globalize("th-TH").numberFormatter({"raw":"0"}),"4":Globalize("th-TH").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.a38390264 = dateToPartsFormatterFn({"2":Globalize("th-TH").numberFormatter({"raw":"00"}),"4":Globalize("th-TH").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.b1705190728 = dateToPartsFormatterFn({"2":Globalize("th-TH").numberFormatter({"raw":"00"}),"4":Globalize("th-TH").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.b1175696456 = dateToPartsFormatterFn({"2":Globalize("th-TH").numberFormatter({"raw":"00"}),"4":Globalize("th-TH").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.b1764258293 = dateToPartsFormatterFn({"1":Globalize("th-TH").numberFormatter({"raw":"0"}),"4":Globalize("th-TH").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.a1817215576 = dateToPartsFormatterFn({"2":Globalize("th-TH").numberFormatter({"raw":"00"}),"4":Globalize("th-TH").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.b1700978009 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"อา","mon":"จ","tue":"อ","wed":"พ","thu":"พฤ","fri":"ศ","sat":"ส"}}}});
Globalize.b747637768 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"วันอาทิตย์","mon":"วันจันทร์","tue":"วันอังคาร","wed":"วันพุธ","thu":"วันพฤหัสบดี","fri":"วันศุกร์","sat":"วันเสาร์"}}}});
Globalize.b2000883208 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"มกราคม","2":"กุมภาพันธ์","3":"มีนาคม","4":"เมษายน","5":"พฤษภาคม","6":"มิถุนายน","7":"กรกฎาคม","8":"สิงหาคม","9":"กันยายน","10":"ตุลาคม","11":"พฤศจิกายน","12":"ธันวาคม"}}}});
Globalize.b728345112 = dateToPartsFormatterFn({"1":Globalize("th-TH").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.b1289068693 = dateToPartsFormatterFn({"1":Globalize("th-TH").numberFormatter({"raw":"0"}),"2":Globalize("th-TH").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.b32023690 = dateToPartsFormatterFn({"1":Globalize("th-TH").numberFormatter({"raw":"0"})}, {"pattern":"d MMM","timeSeparator":":","months":{"M":{"3":{"1":"ม.ค.","2":"ก.พ.","3":"มี.ค.","4":"เม.ย.","5":"พ.ค.","6":"มิ.ย.","7":"ก.ค.","8":"ส.ค.","9":"ก.ย.","10":"ต.ค.","11":"พ.ย.","12":"ธ.ค."}}}});
Globalize.b1012095533 = dateToPartsFormatterFn({"1":Globalize("th-TH").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM","timeSeparator":":","months":{"M":{"4":{"1":"มกราคม","2":"กุมภาพันธ์","3":"มีนาคม","4":"เมษายน","5":"พฤษภาคม","6":"มิถุนายน","7":"กรกฎาคม","8":"สิงหาคม","9":"กันยายน","10":"ตุลาคม","11":"พฤศจิกายน","12":"ธันวาคม"}}}});
Globalize.a746830658 = dateToPartsFormatterFn({"1":Globalize("th-TH").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM G y","timeSeparator":":","months":{"M":{"4":{"1":"มกราคม","2":"กุมภาพันธ์","3":"มีนาคม","4":"เมษายน","5":"พฤษภาคม","6":"มิถุนายน","7":"กรกฎาคม","8":"สิงหาคม","9":"กันยายน","10":"ตุลาคม","11":"พฤศจิกายน","12":"ธันวาคม"}}},"eras":{"0":"ก่อน ค.ศ.","1":"ค.ศ.","0-alt-variant":"ก่อน ส.ศ.","1-alt-variant":"ส.ศ."}});
Globalize.b1638537314 = dateToPartsFormatterFn({"1":Globalize("th-TH").numberFormatter({"raw":"0"})}, {"pattern":"MMMM G y","timeSeparator":":","months":{"M":{"4":{"1":"มกราคม","2":"กุมภาพันธ์","3":"มีนาคม","4":"เมษายน","5":"พฤษภาคม","6":"มิถุนายน","7":"กรกฎาคม","8":"สิงหาคม","9":"กันยายน","10":"ตุลาคม","11":"พฤศจิกายน","12":"ธันวาคม"}}},"eras":{"0":"ก่อน ค.ศ.","1":"ค.ศ.","0-alt-variant":"ก่อน ส.ศ.","1-alt-variant":"ส.ศ."}});
Globalize.b1637852121 = dateToPartsFormatterFn({"1":Globalize("th-TH").numberFormatter({"raw":"0"})}, {"pattern":"d MMM y","timeSeparator":":","months":{"M":{"3":{"1":"ม.ค.","2":"ก.พ.","3":"มี.ค.","4":"เม.ย.","5":"พ.ค.","6":"มิ.ย.","7":"ก.ค.","8":"ส.ค.","9":"ก.ย.","10":"ต.ค.","11":"พ.ย.","12":"ธ.ค."}}}});
Globalize.a1777518774 = dateToPartsFormatterFn({"1":Globalize("th-TH").numberFormatter({"raw":"0"})}, {"pattern":"EEEEที่ d MMM","timeSeparator":":","days":{"E":{"4":{"sun":"วันอาทิตย์","mon":"วันจันทร์","tue":"วันอังคาร","wed":"วันพุธ","thu":"วันพฤหัสบดี","fri":"วันศุกร์","sat":"วันเสาร์"}}},"months":{"M":{"3":{"1":"ม.ค.","2":"ก.พ.","3":"มี.ค.","4":"เม.ย.","5":"พ.ค.","6":"มิ.ย.","7":"ก.ค.","8":"ส.ค.","9":"ก.ย.","10":"ต.ค.","11":"พ.ย.","12":"ธ.ค."}}}});
Globalize.b1019483701 = dateToPartsFormatterFn({"1":Globalize("th-TH").numberFormatter({"raw":"0"})}, {"pattern":"E d MMM","timeSeparator":":","days":{"E":{"1":{"sun":"อา.","mon":"จ.","tue":"อ.","wed":"พ.","thu":"พฤ.","fri":"ศ.","sat":"ส."}}},"months":{"M":{"3":{"1":"ม.ค.","2":"ก.พ.","3":"มี.ค.","4":"เม.ย.","5":"พ.ค.","6":"มิ.ย.","7":"ก.ค.","8":"ส.ค.","9":"ก.ย.","10":"ต.ค.","11":"พ.ย.","12":"ธ.ค."}}}});
Globalize.b320212657 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.b1434759025 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.a292230306 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.b830223652 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.b1380618001 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.b1254066524 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.a417104015 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.b1326476977 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.b796982705 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.a50658914 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.b2099037969 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.b1852151376 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.b1583798321 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.a1457923535 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.b145061519 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"d"}));
Globalize.b1680475774 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.a395834879 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.b633381782 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.b397944949 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.b1259823563 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.b1259138370 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.a1159788223 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.b640769950 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.a1293849086 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.a179302718 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.b497150703 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.b1619604661 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.a233443742 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.b2043447533 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.a2031165758 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.a287584766 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.a817079038 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.b738722095 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.b484976226 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.b46016607 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^อา/],["thu",/^พฤ/],["mon",/^จ/],["tue",/^อ/],["wed",/^พ/],["fri",/^ศ/],["sat",/^ส/]]});
Globalize.a1799600062 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["thu",/^วันพฤหัสบดี/],["sun",/^วันอาทิตย์/],["mon",/^วันจันทร์/],["tue",/^วันอังคาร/],["fri",/^วันศุกร์/],["sat",/^วันเสาร์/],["wed",/^วันพุธ/]]});
Globalize.a546354622 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["2",/^กุมภาพันธ์/],["11",/^พฤศจิกายน/],["6",/^มิถุนายน/],["5",/^พฤษภาคม/],["7",/^กรกฎาคม/],["8",/^สิงหาคม/],["9",/^กันยายน/],["12",/^ธันวาคม/],["1",/^มกราคม/],["3",/^มีนาคม/],["4",/^เมษายน/],["10",/^ตุลาคม/]]});
Globalize.b1702848542 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d","digitsRe":/\d/});
Globalize.b1524872783 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.a1694827376 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["3",/^มี\.ค\./],["4",/^เม\.ย\./],["6",/^มิ\.ย\./],["1",/^ม\.ค\./],["2",/^ก\.พ\./],["5",/^พ\.ค\./],["7",/^ก\.ค\./],["8",/^ส\.ค\./],["9",/^ก\.ย\./],["10",/^ต\.ค\./],["11",/^พ\.ย\./],["12",/^ธ\.ค\./]]});
Globalize.a980679961 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["2",/^กุมภาพันธ์/],["11",/^พฤศจิกายน/],["6",/^มิถุนายน/],["5",/^พฤษภาคม/],["7",/^กรกฎาคม/],["8",/^สิงหาคม/],["9",/^กันยายน/],["12",/^ธันวาคม/],["1",/^มกราคม/],["3",/^มีนาคม/],["4",/^เมษายน/],["10",/^ตุลาคม/]]});
Globalize.b1901638468 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM G y","digitsRe":/\d/,"gregorian/months/format/wide":[["2",/^กุมภาพันธ์/],["11",/^พฤศจิกายน/],["6",/^มิถุนายน/],["5",/^พฤษภาคม/],["7",/^กรกฎาคม/],["8",/^สิงหาคม/],["9",/^กันยายน/],["12",/^ธันวาคม/],["1",/^มกราคม/],["3",/^มีนาคม/],["4",/^เมษายน/],["10",/^ตุลาคม/]],"gregorian/eras/eraAbbr":[["0",/^ก่อน ค\.ศ\./],["0-alt-variant",/^ก่อน ส\.ศ\./],["1",/^ค\.ศ\./],["1-alt-variant",/^ส\.ศ\./]]});
Globalize.a354238180 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM G y","digitsRe":/\d/,"gregorian/months/format/wide":[["2",/^กุมภาพันธ์/],["11",/^พฤศจิกายน/],["6",/^มิถุนายน/],["5",/^พฤษภาคม/],["7",/^กรกฎาคม/],["8",/^สิงหาคม/],["9",/^กันยายน/],["12",/^ธันวาคม/],["1",/^มกราคม/],["3",/^มีนาคม/],["4",/^เมษายน/],["10",/^ตุลาคม/]],"gregorian/eras/eraAbbr":[["0",/^ก่อน ค\.ศ\./],["0-alt-variant",/^ก่อน ส\.ศ\./],["1",/^ค\.ศ\./],["1-alt-variant",/^ส\.ศ\./]]});
Globalize.a354923373 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["3",/^มี\.ค\./],["4",/^เม\.ย\./],["6",/^มิ\.ย\./],["1",/^ม\.ค\./],["2",/^ก\.พ\./],["5",/^พ\.ค\./],["7",/^ก\.ค\./],["8",/^ส\.ค\./],["9",/^ก\.ย\./],["10",/^ต\.ค\./],["11",/^พ\.ย\./],["12",/^ธ\.ค\./]]});
Globalize.b780672080 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEที่ d MMM","digitsRe":/\d/,"gregorian/days/format/wide":[["thu",/^วันพฤหัสบดี/],["sun",/^วันอาทิตย์/],["mon",/^วันจันทร์/],["tue",/^วันอังคาร/],["fri",/^วันศุกร์/],["sat",/^วันเสาร์/],["wed",/^วันพุธ/]],"gregorian/months/format/abbreviated":[["3",/^มี\.ค\./],["4",/^เม\.ย\./],["6",/^มิ\.ย\./],["1",/^ม\.ค\./],["2",/^ก\.พ\./],["5",/^พ\.ค\./],["7",/^ก\.ค\./],["8",/^ส\.ค\./],["9",/^ก\.ย\./],["10",/^ต\.ค\./],["11",/^พ\.ย\./],["12",/^ธ\.ค\./]]});
Globalize.a973291793 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"E d MMM","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["sun",/^อา\./],["thu",/^พฤ\./],["mon",/^จ\./],["tue",/^อ\./],["wed",/^พ\./],["fri",/^ศ\./],["sat",/^ส\./]],"gregorian/months/format/abbreviated":[["3",/^มี\.ค\./],["4",/^เม\.ย\./],["6",/^มิ\.ย\./],["1",/^ม\.ค\./],["2",/^ก\.พ\./],["5",/^พ\.ค\./],["7",/^ก\.ค\./],["8",/^ส\.ค\./],["9",/^ก\.ย\./],["10",/^ต\.ค\./],["11",/^พ\.ย\./],["12",/^ธ\.ค\./]]});
module.exports = Globalize;
